import { PaymentPlan } from '@nemuru-eng/js-api-client';

import { SubSectionWrapper } from '../../../../shared/components/SubSectionWrapper';
import { PaymentPlanDetails } from './components/PaymentPlanDetails';

interface PaymentPlanDetailsSectionProps {
  paymentPlan: PaymentPlan;
}

export const PaymentPlanDetailsSection = ({ paymentPlan }: PaymentPlanDetailsSectionProps) => (
  <SubSectionWrapper>
    <PaymentPlanDetails paymentPlan={paymentPlan} />
  </SubSectionWrapper>
);
